// jquery must not be imported here but the global jquery must be used. Otherwise, bootstrap event listeners are not working
// import $ from "jquery";

class ParticipantsInfo {
    _nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
    _populateInfoModal($modal, participantJson) {
        $.each(participantJson, function(property, value) {
            this._processParticipantField($modal, property, value);
        }.bind(this));
    }

    _processParticipantField($wrapper, property, value) {
        var $propertyField = $wrapper.find('.participant-info-field-' + property);
        if ($propertyField.is(':input')) {
            if (typeof value === 'object') {
                value = value.value;
            }
            if ($propertyField.attr('type') === 'checkbox') {
                $propertyField.prop('checked', value);
            } else {
                $propertyField.val(value);
            }
        } else {
            if (typeof value === 'object') {
                value = value.label;
            }
            value = this._nl2br(value);
            $propertyField.html(value);
        }
    }

    constructor() {
        this.Selectors = {
            participantsTable: '#participants-table',
            participantInfoModal: '#participant-info-modal',
            participantInfoModalForm: '#participant-info-form',
            participantDeleteModal: '#participant-delete-confirmation-modal',
            participantDeleteForm: '#participant-delete-form'
        };

        let $table = $(this.Selectors.participantsTable);
        if(!$table.length) return;
        this.dataTable = $table.DataTable( {
            select: true,
            dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'i>>" +
                "<'row'<'col-sm-12 col-md-6 custom_filters'><'col-sm-12 col-md-6'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-12'p>>",
        });

        let registrationTypeFilter = $('<select class="form-control w-25 d-inline"><option value="">Typ</option></select>')
            .on('change', function(event) {
                let filter = $(event.target).val();
                if (filter === '') {
                    filter = '';
                } else {
                    filter = `^${filter}$`;
                }
                this.dataTable.column(3).search(filter, true, false, true).draw();
            }.bind(this));
        this.dataTable.column(3).data().unique().sort().each(function(d, j) {
            registrationTypeFilter.append(`<option value="${d}">${d}</option>`);
        });
        $table.closest('.dataTables_wrapper').find('.custom_filters')
            .append($('<div/>').append('<span>Filter:&nbsp;</span>').append(registrationTypeFilter))

        this.bindOpenParticipantsInfo();
        this.bindParticipantUpdateForm();
        this.bindParticipantsDelete();
        this.initFrontendEditor();

        $('#participants-info-email-form').find('.participants-info-email-form-spinner').hide();
        $('#participants-info-email-form').on('submit', function() {
            $('#participants-info-email-form').find('.participants-info-email-form-spinner').show();
        })
    }

    bindOpenParticipantsInfo() {
        let $deleteModal = $(this.Selectors.participantDeleteModal);
        $(this.Selectors.participantInfoModal).on('show.bs.modal', function(e) {
            let $trigger = $(e.relatedTarget);
            if ($trigger === undefined) {
                return;
            }

            let ajaxAction = $trigger.data('ajaxAction'),
                $modal = $(e.target);

            $modal.find('.ajax-loading-spinner').show();
            $.ajax({
                url: ajaxAction,
                type: 'GET',
                data: {},
                dataType: 'json',
                success: function(data, textStatus, jqXHR) {
                    $modal.find('.ajax-loading-spinner').hide();
                    $deleteModal.find('.ajax-loading-spinner').hide();
                    $(this.Selectors.participantDeleteForm).find('.participant-identity-input').val(data.uid);
                    this._populateInfoModal($modal, data);
                }.bind(this)
            });
        }.bind(this));
    }

    bindParticipantUpdateForm() {
        let $infoModal = $(this.Selectors.participantInfoModal),
            $infoModalForm = $(this.Selectors.participantInfoModalForm);

        $infoModalForm.on('submit', function(e) {
            e.preventDefault();

            $infoModal.find('.ajax-loading-spinner').show();
            $.ajax({
                url: $infoModalForm.data('ajaxAction'),
                type: 'POST',
                data: $infoModalForm.serialize(),
                dataType: 'json',
                success: function(data, textStatus, jqXHR) {
                    $infoModal.find('.ajax-loading-spinner').hide();
                    $infoModal.modal('hide');
                    // todo update participant in table
                }
            });
        });
    }

    bindParticipantsDelete() {
        let $deleteModal = $(this.Selectors.participantDeleteModal),
            $deleteForm = $(this.Selectors.participantDeleteForm);

        $deleteForm.on('submit', function(e) {
            e.preventDefault();
            $deleteModal.find('.ajax-loading-spinner').show();
            $.ajax({
                url: $deleteForm.data('ajaxAction'),
                type: 'POST',
                data: $deleteForm.serialize(),
                dataType: 'json',
                success: function(data, textStatus, jqXHR) {
                    $deleteModal.find('.ajax-loading-spinner').hide();
                    $deleteModal.modal('hide');
                    $(this.Selectors.participantInfoModal).modal('hide');
                    $(this.Selectors.participantsTable).DataTable().row('#participants-table-entry-' + data.uid).remove().draw();
                }.bind(this)
            });
        }.bind(this));
    }

    initFrontendEditor() {
        if (CKEDITOR === undefined) {
            return;
        }

        var defaultckeditorSettings = {};
        try {
            defaultckeditorSettings = LumIT.Conmanager.Constants.ckeditorSettings;
        } catch (exception) {
            // just avoid a breaking exception
        }

        let ckeditorSettings = $.extend(true, {}, defaultckeditorSettings, {
            language: 'de',
            uiColor: '#ffffff',
            extraPlugins: 'smiley',
            contentsCss: '/typo3conf/ext/iglarp_template/Resources/Public/assets/dist/footer.css',
            toolbarGroups: [
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'links', groups: [ 'links' ] },
                { name: 'colors', groups: [ 'colors' ] },
                '/',
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'editing' ] },
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'forms', groups: [ 'forms' ] },
                { name: 'others', groups: [ 'others' ] },
                { name: 'about', groups: [ 'about' ] }
            ],
            removeButtons: 'spellchecker,Save,NewPage,Preview,Print,Templates,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Subscript,Superscript,Outdent,Indent,CreateDiv,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,PageBreak,Iframe,Font,ShowBlocks,About',
            allowedContent: {
                '*': {attributes: ['id', 'title']},
                a: {attributes: ['target', 'ping', 'media', '!href', 'hreflang', 'type', 'rel']},
                'blockquote q': {attributes: ['cite']},
                img: {attributes: ['alt', '!src', 'ismap', 'usemap', 'width', 'height']},
                ol: {attributes: ['reversed', 'start']},
                li: {attributes: ['value']},
                ul: true,
                'dl dt dd': true,
                'table thead tbody tfoot tr': true,
                'th td': {attributes: ['colspan', 'rowspan', 'headers']},
                footer: true,
                hr: true,
                'div p pre code': true,
                'h1 h2 h3 h4 h5 h6': true,
                //inline tags
                'br big small em i strong b u s mark sub sup': true,
                'span': true
            }
        });
        let ckeditorSettingsLight = $.extend(true, {}, defaultckeditorSettings, {
            language: 'de',
            toolbarGroups: [
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                { name: 'forms', groups: [ 'forms' ] },
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                { name: 'links', groups: [ 'links' ] },
                { name: 'insert', groups: [ 'insert' ] },
                { name: 'styles', groups: [ 'styles' ] },
                { name: 'colors', groups: [ 'colors' ] },
                { name: 'tools', groups: [ 'tools' ] },
                { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                { name: 'others', groups: [ 'others' ] },
                { name: 'about', groups: [ 'about' ] }
            ],
            removeButtons: 'Save,Templates,Cut,NewPage,Preview,Print,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Superscript,Subscript,Strike,NumberedList,BulletedList,Outdent,Indent,Blockquote,CreateDiv,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Styles,Format,Font,FontSize,TextColor,BGColor,ShowBlocks,About',
        });

        $('.conmanager-ckeditor').each(function() {
            CKEDITOR.replace(this.id, ckeditorSettings);
        });
        $('.conmanager-ckeditor-light').each(function() {
            CKEDITOR.replace(this.id, ckeditorSettingsLight);
        })
    }
}

export default ParticipantsInfo;